import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../app/AuthContext";

export function SubmitBrandPage() {
  const { user } = useAuth();
  const [url, setUrl] = useState("");
  const [message, setMessage] = useState("");
  const [result, setResult] = useState<{ submissionId: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null); setPending(true);
    try {
      const r = await api.me.submit(url.trim(), message.trim() || undefined);
      setResult(r);
      setUrl(""); setMessage("");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Submission failed");
    } finally {
      setPending(false);
    }
  };

  if (!user) {
    return (
      <div className="container empty-state">
        <p>Sign in to submit a brand.</p>
        <Link to="/login"><button className="primary">Sign in</button></Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingBlock: "2rem", maxWidth: 640 }}>
      <h2>Submit a brand</h2>
      <p style={{ color: "var(--fg-muted)", marginTop: "1rem" }}>
        Submit a brand website or Instagram handle. The discovery pipeline will analyze it,
        check for duplicates and either publish it automatically or send it to admin review.
      </p>
      <form onSubmit={onSubmit} style={{ marginTop: "1.5rem", display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        <label>
          <div style={{ marginBottom: "0.4rem", color: "var(--fg-muted)", fontSize: "0.85rem" }}>Brand URL</div>
          <input type="url" required value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://examplebrand.com" />
        </label>
        <label>
          <div style={{ marginBottom: "0.4rem", color: "var(--fg-muted)", fontSize: "0.85rem" }}>Notes (optional)</div>
          <textarea rows={3} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Anything we should know?" />
        </label>
        <button type="submit" className="primary" disabled={pending}>{pending ? "Submitting…" : "Submit brand"}</button>
        {error && <div style={{ color: "var(--danger)" }}>{error}</div>}
        {result && <div style={{ color: "var(--ok)" }}>Thanks — submission {result.submissionId} received.</div>}
      </form>
    </div>
  );
}
